import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TweenMax, Quint } from 'gsap';
import { ModalTermsComponent } from '../../shared/modal-terms/modal-terms.component';
import { ThemeService } from '../../shared/theme-service/theme.service';
import { AutenticationService } from '../autentication.service';

@Component({
	selector: 'app-channels-and-fees',
	templateUrl: './channels-and-fees.component.html',
	styleUrls: ['./channels-and-fees.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ChannelsAndFeesComponent implements OnInit {
	phoneCrCapital = '4004 3500';
	phoneCrMore = '0800 701 3500';
	phoneSAC = '0800 727 0885';
	modalHidden = true;

	constructor(
		private themeService: ThemeService,
		private dialog: MatDialog,
		private service: AutenticationService
	) { }

	ngOnInit() {
		this.definePhonesByTheme();
	}

	definePhonesByTheme() {
		switch (this.themeService.currentURL) {
			case 'www.powerclub.com.br':
				this.phoneCrCapital = '4003 0583';
				this.phoneCrMore = '0800 770 6301';
				this.phoneSAC = '0800 770 6302';
				break;
			case 'www.uzeconta.com.br':
				this.phoneSAC = '0800 777 6266';
				break;
		}
	}

	openModalChannel() {
		this.modalHidden = false;

		TweenMax.to('[data-component="channels-and-fees"] .modal-channels', .5, {
			opacity: 1,
			autoAlpha: 1,
			bottom: '150%',
			ease: Quint.easeOut
		});
	}

	closeModalChannel() {
		TweenMax.to('[data-component="channels-and-fees"] .modal-channels', .5, {
			opacity: 0,
			autoAlpha: 0,
			bottom: '100%',
			ease: Quint.easeOut,
			onComplete: () => {
				this.modalHidden = true;
			}
		});
	}

	openModalTerms() {
		this.service.getTerms().subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.dialog.open(ModalTermsComponent, {
					width: '700px',
					height: '500px',
					data: {
						title: 'Termos de uso e política de privacidade',
						text: data.Retorno
					}
				});
			}
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/channels-and-fees/channels-and-fees.component.ts